import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const NewRecordsConfirmModal = ({ open, onContinue, onCancel, tableName, newRecordsCount }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" />
          <Typography variant="h6">New Records Detected</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="body1">
            {newRecordsCount > 0 
              ? `${newRecordsCount} new record(s) have been added to the ${tableName} table.`
              : `New records have been added to the ${tableName} table.`
            }
          </Typography>
        </Alert>
        <Typography variant="body2" color="text.secondary">
          You can continue with the refresh process or cancel to review the new records first.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          Cancel & Review
        </Button>
        <Button onClick={onContinue} variant="contained" color="primary">
          Continue Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewRecordsConfirmModal;
